import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartItems: [],
  totalQuantity: 0,
  totalAmount: 0,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { product, size="1kg", quantity="1", price=0 } = action.payload;
      console.log('cart product:', action.payload)
      const existingItem = state.cartItems.find(
        (item) => item.product.id === product.id && item.size === size
      );
      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        state.cartItems.push({ product, size, quantity });
      }
      state.totalQuantity += quantity;
      state.totalAmount += product.price * quantity;
      localStorage.setItem('cart', JSON.stringify(state.cartItems));
    },
    removeFromCart: (state, action) => {
      const { productId, size } = action.payload;
      const existingItem = state.cartItems.find(
        (item) => item.product.id === productId && item.size === size
      );
      if (existingItem) {
        state.totalQuantity -= existingItem.quantity;
        state.totalAmount -= existingItem.product.price * existingItem.quantity;
        state.cartItems = state.cartItems.filter(
          (item) => item.product.id !== productId || item.size !== size
        );
      }
    },
    updateCartItem: (state, action) => {
      const { productId, size, quantity } = action.payload;
      const existingItem = state.cartItems.find(
        (item) => item.product.id === productId && item.size === size
      );
      if (existingItem) {
        state.totalQuantity -= existingItem.quantity;
        state.totalAmount -= existingItem.product.price * existingItem.quantity;
        existingItem.quantity = quantity;
        state.totalQuantity += quantity;
        state.totalAmount += existingItem.product.price * quantity;
      }
    },
    clearCart: (state) => {
      state.cartItems = [];
      state.totalQuantity = 0;
      state.totalAmount = 0;
    },
    loadCartFromLocalStorage: (state) => {
      const cartFromLocalStorage = localStorage.getItem('cart');
      console.log(cartFromLocalStorage)
      if (cartFromLocalStorage) {
        console.log('cartFromLocalStorage:', JSON.parse(cartFromLocalStorage))
        state.cartItems = JSON.parse(cartFromLocalStorage);
        state.totalQuantity = state.cartItems.reduce((total, item) => total + item.quantity, 0);
        state.totalAmount = state.cartItems.reduce((total, item) => total + item.product.price * item.quantity, 0);
      }
    },
  },
});

export const { addToCart, removeFromCart, updateCartItem, clearCart, loadCartFromLocalStorage } = cartSlice.actions;
export default cartSlice.reducer;